export const BalanceTransactionType = {
    wallet_transfer: "wallet_transfer",
    balance_transfer: "balance_transfer",
    sale: "sale",
    manual_deposit: "manual_deposit",
    shift_settlement: "shift_settlement",
    expense: "expense",
    salary: "salary",
    supplier_payment: "supplier_payment",
    customer_payment: "customer_payment",
    customer_return: "customer_return"
} as const;
export type BalanceTransactionType = (typeof BalanceTransactionType)[keyof typeof BalanceTransactionType];
export const BalanceType = {
    cash: "cash",
    wallet: "wallet",
    visa: "visa"
} as const;
export type BalanceType = (typeof BalanceType)[keyof typeof BalanceType];
export const ExpenseCategoryOld = {
    electricity: "electricity",
    internet: "internet",
    rent: "rent",
    other: "other"
} as const;
export type ExpenseCategoryOld = (typeof ExpenseCategoryOld)[keyof typeof ExpenseCategoryOld];
export const CustomerStatus = {
    active: "active",
    suspended: "suspended",
    delete: "delete",
    removed: "removed"
} as const;
export type CustomerStatus = (typeof CustomerStatus)[keyof typeof CustomerStatus];
export const Platform = {
    ios: "ios",
    android: "android",
    web: "web"
} as const;
export type Platform = (typeof Platform)[keyof typeof Platform];
export const NotificationStatus = {
    granted: "granted",
    denied: "denied"
} as const;
export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus];
export const EmployeeRole = {
    cashier: "cashier",
    admin: "admin",
    worker: "worker",
    employee: "employee"
} as const;
export type EmployeeRole = (typeof EmployeeRole)[keyof typeof EmployeeRole];
export const TransactionStatus = {
    normal: "normal",
    cancelled: "cancelled",
    edited: "edited"
} as const;
export type TransactionStatus = (typeof TransactionStatus)[keyof typeof TransactionStatus];
export const TransactionType = {
    purchase: "purchase",
    return: "return"
} as const;
export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType];
export const MovementType = {
    SALE: "SALE",
    RESTOCK: "RESTOCK",
    ADJUSTMENT: "ADJUSTMENT",
    RETURN: "RETURN"
} as const;
export type MovementType = (typeof MovementType)[keyof typeof MovementType];
export const StoragePlaceTransferStatus = {
    pending: "pending",
    completed: "completed",
    failed: "failed"
} as const;
export type StoragePlaceTransferStatus = (typeof StoragePlaceTransferStatus)[keyof typeof StoragePlaceTransferStatus];
export const LogStatus = {
    success: "success",
    failure: "failure"
} as const;
export type LogStatus = (typeof LogStatus)[keyof typeof LogStatus];
export const LogAction = {
    GET: "GET",
    POST: "POST"
} as const;
export type LogAction = (typeof LogAction)[keyof typeof LogAction];
export const ImageEntity = {
    product: "product",
    section: "section",
    collection: "collection",
    announcement: "announcement",
    brand: "brand"
} as const;
export type ImageEntity = (typeof ImageEntity)[keyof typeof ImageEntity];
export const announcementEntity = {
    product: "product",
    section: "section",
    collection: "collection"
} as const;
export type announcementEntity = (typeof announcementEntity)[keyof typeof announcementEntity];
export const NotificationAudience = {
    all: "all",
    registered: "registered",
    unregistered: "unregistered",
    group: "group",
    customer: "customer"
} as const;
export type NotificationAudience = (typeof NotificationAudience)[keyof typeof NotificationAudience];
export const OrderStatus = {
    pending: "pending",
    confirmed: "confirmed",
    preparing: "preparing",
    out_for_delivery: "out_for_delivery",
    delivered: "delivered",
    cancelled: "cancelled",
    rejected: "rejected",
    delivery_failed: "delivery_failed"
} as const;
export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];
export const OrderPaymentMethod = {
    cod: "cod"
} as const;
export type OrderPaymentMethod = (typeof OrderPaymentMethod)[keyof typeof OrderPaymentMethod];
export const OrderSource = {
    app: "app",
    phone: "phone",
    whatsapp: "whatsapp",
    pos: "pos",
    manual: "manual"
} as const;
export type OrderSource = (typeof OrderSource)[keyof typeof OrderSource];
export const OP = {
    upsert: "upsert",
    delete: "delete"
} as const;
export type OP = (typeof OP)[keyof typeof OP];
export const InboxType = {
    shift_start: "shift_start",
    receipt_new: "receipt_new",
    shift_end: "shift_end"
} as const;
export type InboxType = (typeof InboxType)[keyof typeof InboxType];
export const ShiftStatus = {
    open: "open",
    pending: "pending",
    confirmed: "confirmed"
} as const;
export type ShiftStatus = (typeof ShiftStatus)[keyof typeof ShiftStatus];
export const ProductType = {
    STANDARD_PRODUCT: "STANDARD_PRODUCT",
    LOCAL_PRODUCT: "LOCAL_PRODUCT",
    WEIGHT_PRODUCT: "WEIGHT_PRODUCT",
    WEIGHT_DEFINED_PRODUCT: "WEIGHT_DEFINED_PRODUCT"
} as const;
export type ProductType = (typeof ProductType)[keyof typeof ProductType];
export const CustomerReturnStatus = {
    active: "active",
    cancelled: "cancelled"
} as const;
export type CustomerReturnStatus = (typeof CustomerReturnStatus)[keyof typeof CustomerReturnStatus];
export const Status = {
    active: "active",
    inactive: "inactive"
} as const;
export type Status = (typeof Status)[keyof typeof Status];
export const Role = {
    owner: "owner",
    employee: "employee"
} as const;
export type Role = (typeof Role)[keyof typeof Role];
export const PaymentMethod = {
    cash: "cash",
    card: "card",
    wallet: "wallet"
} as const;
export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];
export const CustomerTransactionType = {
    PAYMENT: "PAYMENT",
    ORDER_DEBT: "ORDER_DEBT",
    REFUND: "REFUND",
    ADJUSTMENT: "ADJUSTMENT"
} as const;
export type CustomerTransactionType = (typeof CustomerTransactionType)[keyof typeof CustomerTransactionType];
